import api from "../lib/axios";

export const getAllRoles = async () => {
  const res = await api.get(`/role/getAllRoles`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getAllTabs = async () => {
  const res = await api.get(`/role/getAllTabs`, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getRoleWithPrivileges = async (roleId, eventId, token) => {
  const res = await api.get(`/role/getRoleWithPrivileges`, {
    params: {
      role_id: roleId,
      event_id: eventId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const updateAllRolePrivileges = async (eventId, rolesPayload, token) => {
  const res = await api.post(
    `/role/updateAllRolePrivileges`,
    {
      event_id: eventId,
      roles: rolesPayload,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    },
  );
  return res;
};
